/** 旧版裁切视角按钮 eye_2.png 的内联数据，避免宿主额外配置资源路径。 */
export const FOCUS_ICON_DATA_URL = [
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICA',
  'gIfAhkiAAAAAlwSFlzAAAdhwAAHYcBj+XxZQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5',
  'vuPBoAAAszSURBVHic7Vt7VJTXEf8tEliQCOwBxaKsq6QYMD5Q8BnQJkZ8BUh8kNNYY320qamakzRCUh',
  '9Vo8ZYNdg0aTWKJpGHokQTPZaYnERAA4QS6wtUrA9AYdmFRcLr253+8e23uXz7fbsLLJhzypwzh73z3Z',
  'm5M9+9M3Pv/QB6oAd6oAd6oAceFrgCcHuYA1B0g45eAJ4AMBZAJIDhAPwBqAA8au5jAKAFUAEgH0AOgF',
  'wAVd0wvi6DMADrAdwEQB1AI3hHLAPg2b1D7xzMAlAAB4x0dXUlNzc3R5xRAyARXeAIZy6BiQB2AogQPw',
  'gICMDkydGIjIxAREQEBg4cAJVKhUcf5VeAwWBAdXU1SkpKkZubh5ycHOTm5sFoNIpFVQJYB2AveMf8LM',
  'ATwFYAHJi35unpSYsWvUTZ2aeJ45qJiGsXlpffps2bN9GQIUOkZsRZAMEPyd42EA7RGnd3d6dly5ZSRc',
  'WddhsthUZjC2VkpJFGoxE7wQAg4aFZDmABgB/ZQc2ePYvu3PmvUwwXY2PjA0pKSiRXV1fWCSYA74DPNN',
  '0Ka1jDfXx8KC3tUJcYLsb8/PMUEhIing2fAVB2xJD2BkEFgHcBvCYQhg0Lw7FjmQgOtr8km5qaUFz8A4',
  'qKinD3bjlqa2uhUCjg5+eHwYM1iI6OwqBBg+zKMRgMWLBgIY4fP8GSvwYQC6C+nTa1C7aB8XxMzDSqr6',
  '+1u4aPH8+iefPmkqenp92UN3ToUNq+fRtptfftyl29+g0xfy6A3l1l/Gussjlznqfm5h9tDjIjI41CQ0',
  'M7UgRRnz59aMOG9fTgQZ1NHe+++w4pFAqWNxsdXA62YCb4gEMAKD4+zmZqKyu7Rk899SubBioUCurXrx',
  '8FBQWRUqmU7afRaOirr7606YTdu98T8x2CE2scNfg6nQBQdHQUNTY+kB1MZuZh8vb2lp3eGzasp+LiIm',
  'ptbWrDV1l5l1JS9lFs7LPk4uJi5aykpEQyGltk9W7Z8rZYX6IzjHcDcF4QGhQUZHNt7t79ntXgAVBgYC',
  'Dt3/+RwwXRhQvFFBMzzUrOjBnTbS6J5cv/IN5LzOqsA3YJAt3c3OjcuVxZ5Rs3/kXyrU+cOIHu368gIo',
  '44rpkqKu5Y2rbQZGqlLVvetnJoVNSTsoG3paWRpkyZzPavA/B4R42fDGbd79q1Q3awb731pqTxzzwzlZ',
  'qaGkirvU8rV64gPz8/y7MBAwbQ2rVrqKHBYNMRBw+miIMcTZo0kQwGvWT/6up74qqxGIB7e413A3BZEB',
  'IfH0cmU6ukwn379squd71eSzdulEqVsRYcOXKE3ZSXlJRoxTd+/DjZmXDhQrE45b7TXgckCcze3t6ydf',
  '0333wtu53NzT1Lra1NNHz4E+JnVQD0LG3GjOk2HcBxzRQWZp1O4+JiZQPj++/vFseDKEeNDwTQIDAnJ+',
  '+SVFBZeZf8/f0ljY+LiyUijlJTP2XpDQDizDpcACwFs4O0FV+IODp+PEtSV1JSomwMEQXSa3CwPkgWmM',
  'LDR8lG7lmzZrLCK8CXoASAsrNPExFHCxa8yPb5s4QuYV9Pa9eusRsU1Wq1lQMUCgWlp6dK8pSX3yaVSm',
  'VvDG2gP4BGgeH06VOSgvfu/ad4ev1OaPv4+FBLSyMRcTR16tNsv6kS+pYKz5csWWw3M6xY8UdWnonVee',
  'tWmSTPBx+8L56FQbYcsEPoPG7cWEmBWu19sVd3AogR2tOmPWPp+8ILCWy/VyX0vSc8l5vKLGZkpLHyTg',
  'O4LrSjo6Mk4wHHNVN4+CiWL03OeG8w0/jkyc8lB/Hyy78XrysPAIsE2qJFL8nNlBq0PS6bCaBJeH7mTL',
  'ZdB+TmnmXl5QIYB6BVoH300R5Jvry8HDaVmgCMknLAEkHQsGFhkoJKS6+IDyRmm3lfF2ivv/6apX9j4w',
  'NxCjQCKAJwiaHRhAnjZdMsiyUll1lZJWbdmwRa3759Sa/XOhKz/ioY7cI44Lbwg4gkp8i3354Fx3Fsf2',
  'FDrhOIOp3lJ5RKJTIzD0OlUrH6RgEIFQhqtRqpqZ9CobC/d6mp0bVpmv9uBh+EUVVVhZSUA5K8DQ0NbL',
  'NQqo8HmCOu69dLrLyo12vFBUa4mXe6QIuJmWbFV1Z2jebMeZ4eeeQRC6+HhwctXvxbqqqqtPvmBTx8OJ',
  '3VfcSs2xdM2i4o+M6Kr7a2hq1XTAAC5JycJQhat26t5CAWLvwNO4h0M98vBRqbBcRYV6ej7747R0VFhX',
  'ZLYClctWolq3ubWfebAi08fJQjWStfzngAeE7oqFarJaPq998XiAPKaDOvJSI7EtA6gqJ4MsX89nUCLS',
  'VlnyRfdHQUy7fKlgPcwJeqBICOHcuUFDh37hxW4Dnwp7KWFBofH+d040+e/JzVqQV/sWop2kJCQqzOGI',
  'g4unjxAvvCWgH0s+UAANgiCB09Olw2Gru7u7MD+hP4C1AjzNXZ+fN5TjPeaGwR7yl2Apgk6ANAR45kSP',
  'K++OKvpeKGTegLJqh88cUJScGbN29iBTeCv/U9KNBCQ0Oprk7nFAesW7eW1VUHYDD4NEgAfx8hxXfz5n',
  'Vx2h7jiAMAZjqPHRspmaNbW5tozJjRrPAb4OPBA4E2c+YM2YDoKKanp4rPA5IAZAptb29vunv3liTvsm',
  'VLWb5/OWo8APwCzJ7gwIH9kgquXr1Effr0YZWcB18VWur0KVMmU3X1vQ4Zv2PHdurVqxcr/ySAvzFtOn',
  'ToE0neH374t5h3SnscAPAFBgGggIAAqqmpklSUlXVUfGyVIx6kWq2mQ4c+sXmoKXbss8/OZmUSgKsA9r',
  'O0V19dJRszoqKeZHlPtdd4gL9guCMISUiYLzvgDz/8u3ialgD4GKIb4xEjhtO2bVvp6tVLVjLq6nSUnp',
  '5K8+fPE69bAvAfAHksLSFhvqxDk5N3sbwtAIZ2xAEAf6pqEXbwYIqsE5KTd4lnQjP4DUs92hpDAEipVJ',
  'JGo6GwsFDy9fW1eo6f6ox7AKpZ+rx5c2Vjy6VLF6h3796sjI0dNV6APYIwDw8PKizMl3XC0aNHxMoJfF',
  'BsgLSB9tDIthUKBa1e/Ybsxkmv19Jjjz3G8hfDCR9heQG4KAgdOHAg3b59U9YJpaVXaPz4cR0x1ib279',
  '9fNiUTcdTU1CA+gKkH/52SUyAYTMkZHBxM5eW3ZQfDcc20Z88/KCgoqNOGe3l5UVJSIul01bL6WloaKS',
  '4uVrx0nnOW8QI8BeYAIyQkhMrKrtmM5s3NP9LHHx+g6dNjpAKbTYyIGEM7dmy3u1tsaDBQfHycmP8tR4',
  '1q7wXiLPBFiBsA+Pv7IyvrKCZMGG+Xsba2Fvn5BSgsLERJSSn0ej30ej1MJhN8fX3h4+MDjUaD0aPDER',
  'ExBoGBgXZlVlZWIjY2HgUFbbb3W8EXS10G8WCKJKVSSdu3b3M4xzsLT536ggIDA8Vvvt0XIB2FceDTk0',
  'X5pEkTqaTkcpcbrtdracmSxeK6oxX8yXS3ghqiDyJdXFxo7tw5dO3aVacbXl9fS1u3bpaqGe4BeLq7jR',
  'fAFcBqMMER4G+SExLm04kTn3VqM2QytVJeXg698spyuWIpA4BfZwxw1lcUI8B/PGV1+eHn54eYmGmIiB',
  'iDyMhIjBw5Akql9A0Vx3G4ePESCgsLUVBQiC+/PIOysjKprlfAR/pjnR24s78WfxLABvBX67Lg5eUFlU',
  'oFlcoXLi4u0On00Ol0MBgM9uSXgC9t08BXiT9beBz8l+KWc8JOoB78QcvTaHuM7xTo6v8XUIA/JBkL/l',
  'YoEsAQyNfnRgC3wJ/bF5jxHPgdXZcN8GGAF/h/mFCBf6s68G+67iGNpwd6oAd6oAd64P8R/gfeVWNCzD',
  '2PhwAAAABJRU5ErkJggg==',
].join('')
